export default {
  apiUrl: process.env.NODE_ENV === 'production'
    ? 'https://event.audibratislava.sk/api/'
    : 'https://event.audibratislava.sk/api/',
  GOOGLE_TAG_MANAGER_CODE: 'GTM-',
  GOOGLE_ANALYTICS_CODE: 'UA--3',
  FACEBOOK_PIXEL_CODE: '',
};
